<template>
  <div>
    <swiper ref="mySwiper" :options="swiperOptions"  v-if="banners.length>0">
      <!-- <swiper-slide v-if="banners.length == 0" >
        <img src="../assets/images/backgroud.png" alt="" style="width: 100%" />
      </swiper-slide> -->
      <!-- <template v-else> -->
        <swiper-slide v-for="item in banners" :key="item.id" @click.native="goUrl(item.redirectUrl)" style="cursor:pointer">
          <el-image
            :src="item.picUrl"
            style="width: 100%"
          />
        </swiper-slide>
      <!-- </template> -->
      <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
    </swiper>
    <div class="width-max">
      <div class="feature">
        大赛特色介绍
        <img src="@/assets/images/tese.png" alt="" />
      </div>
      <el-row
        style="margin-top: 20px"
        type="flex"
        justify="space-between"
        :gutter="40"
      >
        <el-col class="feature-div" v-for="item in feature" :key="item.id">
          <div>
            <div class="feature-text">{{ item.title }}</div>
            <div class="feature-des">{{ item.content }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="jianjie">
      <div class="feature">
        大赛简介
        <img src="@/assets/images/intr.png" alt="" />
      </div>
      <div class="infobox width-max">
        <div class="jianjie-text" v-html="info.briefIntro"></div>
        <div class="details" @click="goIntro">查看详情</div>
      </div>
    </div>
    <div class="timeline">
      <div class="width-max">
        <div class="feature">
          大赛时间表
          <img src="@/assets/images/timebg.png" alt="" />
        </div>
        <el-row
          :gutter="49"
          class="timebook"
          type="flex"
          justify="space-between"
        >
          <el-col v-for="item in times" :key="item.id">
            <div class="timebook-div">
              <div class="tb-time">{{ item.time }}</div>
              <img src="../assets/images/time.png" alt="" />
              <div class="tb-title">{{ item.title }}</div>
              <div class="tb-text" v-html="item.content"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="new-list">
      <div class="width-max">
        <div class="feature">
          新闻公告
          <img src="@/assets/images/news.png" alt="" />
        </div>
        <swiper ref="mySwiper2" class="mySwiper2" :options="swiperOptions2">
          <swiper-slide
            class="news-div"
            v-for="item in news"
            :key="item.id"
            @click.native="goNews"
          >
            <img :src="item.img" class="news-img" />
            <div class="news-text">
              <div class="news-title">{{ item.title }}</div>
              <div class="news-con" v-html="item.content"></div>
              <div>
                <div class="news-time">{{ item.time }}</div>
                <!-- <el-link type="primary" @click="goNews">查看更多</el-link> -->
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { GetFeature, GetPageNews, GetTime, GetBanner } from "@/api/home";
export default {
  name: "Home",
  data() {
    return {
      banners: [],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
         navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptions2: {
        slidesPerView: 4,
        spaceBetween: 14,
      },
      feature: [
        {
          title: "",
          content: "",
          img: "",
        },
        {
          title: "",
          content: "",
          img: "",
        },
        {
          title: "",
          content: "",
          img: "",
        },
      ],
      news: [],
      times: [
        {
          title: "",
          time: "",
          content: "",
        },
        {
          title: "",
          time: "",
          content: "",
        },
        {
          title: "",
          time: "",
          content: "",
        },
        {
          title: "",
          time: "",
          content: "",
        },
      ],
    };
  },
  computed: {
    competitionId() {
      return this.$store.getters.competitionId;
    },
    info() {
      let info = this.$store.getters.info;
      return info;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    goUrl(url){
      if(url.trim()){
        window.open(url)
      }
    },
    goIntro() {
      this.$router.push("/pc/cintroduction");
    },
    goNews() {
      this.$router.push("/pc/news");
    },
    getInfo() {
      GetBanner(this.competitionId).then(({ data }) => {
        this.banners = data;
      });
      this.getFeature();
      this.getNews();
      this.getTime();
    },
    getFeature() {
      GetFeature(this.competitionId).then((res) => {
        this.feature = res.data;
      });
    },
    getNews() {
      const param = {
        ciId: this.competitionId,
        pageNum: 1,
        pageSize: 10,
      };
      GetPageNews(param).then((res) => {
        var regex = /(<([^>]+)>)/gi;
        this.news = res.list.map((val) => {
          val.content = val.content.replace(regex, "");
          return val;
        });
      });
    },
    getTime() {
      GetTime(this.competitionId).then((res) => {
        var regex = /(<([^>]+)>)/gi;
        this.times = res.data.map((val) => {
          val.content = val.content.replace(regex, "");
          return val;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 50px;
  font-weight: 600;
  color: white;
  margin-bottom: 20px;
}
.apply-btn {
  margin-top: 36px;
}
.btn-text {
  font-size: 18px;
  color: white;
}
.feature {
  margin-top: 83px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  color: #000000;
  position: relative;
  text-align: center;
  margin-bottom: 38px;
  line-height: 1;
  img {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translate(-50%);
  }
}

.feature-div {
  flex: 1;
  > div {
    height: 330px;
    border-radius: 8px;
    overflow: hidden;
    background: url("../assets/images/feature.png");
    border: 2px solid #ffffff;
    box-shadow: 0px 5px 50px 0px rgba(55, 99, 170, 0.1);
    border-radius: 8px;
    .feature-text {
      margin-top: 45px;
      font-size: 24px;
      font-family: YouSheBiaoTiHei;
      color: #366aff;
      line-height: 24px;
      text-align: center;
    }
    .feature-des {
      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #16181a;
      line-height: 24px;
      margin: 194px 50px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
    }
  }
}

.jianjie {
  margin: 39px auto 0;
  background: #fff;
  background: url("../assets/images/msg.png") no-repeat 50%/1920px 100%;
  position: relative;
  height: 534px;
  max-width: 1920px;
  overflow: hidden;
  .feature {
    margin-top: 92px;
  }
}
.infobox {
  padding: 50px 0 50px 50px;
  font-size: 16px;
  line-height: 28px;
  border-radius: 50px 0 0 50px;
  text-align: center;
  &.bg {
    backdrop-filter: blur(15px);
  }
}
.jianjie-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7; // 控制多行的行数
  -webkit-box-orient: vertical;
  color: #333;
}
.details {
  display: inline-block;
  width: 140px;
  height: 40px;
  font-size: 16px;
  color: #fff;
  margin-top: 34px;
  cursor: pointer;
  border-radius: 20px;
  background: #366aff;
  text-align: center;
  line-height: 40px;
}

.timeline {
  .feature {
    margin-top: 82px;
    margin-bottom: 40px;
  }
}

.mySwiper2 {
  width: 1162px;
}

.new-list {
  background: #f5f7fc;
  box-shadow: 0px 2px 35px 0px rgba(163, 166, 199, 0.29);
  height: 536px;
  > .width-max {
    overflow: hidden;
  }
  .feature {
    margin-bottom: 40px;
  }
}
.news-div {
  height: 220px;
  cursor: pointer;
  &:hover .news-text {
    height: 162px;
    padding: 23px 17px 0;
    .news-con {
      -webkit-line-clamp: 3; // 控制多行的行数
      height: 61px;
      line-height: 20px;
    }
  }
  .news-img {
    width: 100%;
    height: 100%;
  }
  .news-text {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 20px 17px 0;
    height: 77px;
    transition: all 0.3s;
  }

  .news-title {
    margin-bottom: 15px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; // 控制多行的行数
    -webkit-box-orient: vertical;
    line-height: 1;
  }

  .news-con {
    color: #8d96b7;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 1;
    -webkit-line-clamp: 1; // 控制多行的行数
    -webkit-box-orient: vertical;
    & + div {
      margin-top: 14px;
      display: flex;
      justify-content: space-between;
    }
  }
}

.timebook {
  width: 100%;
  display: flex;
  align-items: stretch;
  padding-bottom: 55px;
  > div {
    flex: 1;
  }
}
.timebook-div {
  box-sizing: border-box;
  background: linear-gradient(180deg, #eef3f9, #ffffff);
  border: 2px solid #ffffff;
  box-shadow: 0px 5px 50px 0px rgba(55, 99, 170, 0.1);
  border-radius: 20px 0px 0px 20px;
  text-align: center;
  position: relative;
  height: 357px;
  > img {
    margin-top: 30px;
  }
  .tb-title {
    position: absolute;
    top: 209px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 30px;
    font-family: YouSheBiaoTiHei;
    color: #366aff;
    white-space: nowrap;
  }
}

.tb-time {
  margin-top: 38px;
  font-size: 18px;
  font-weight: bold;
  color: #366aff;
}
.tb-text {
  margin: 13px 20px 0;
  color: #16181a;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; // 控制多行的行数
  -webkit-box-orient: vertical;
  margin-bottom: 33px;
}
</style>
